module.exports = __webpack_public_path__ + "static/media/facebook.61aef0e0.svg";